'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var getStateKey = function getStateKey(renderedElement) {
  return typeof renderedElement.ref === 'string' ? renderedElement.ref : renderedElement.key;
};

exports.default = getStateKey;


//////////////////
// WEBPACK FOOTER
// ./~/radium/lib/get-state-key.js
// module id = 681
// module chunks = 0